export class GenerateSessionId {
    handle() {
        const characters = '0123456789abcdef';
        const segments = [8, 4, 4, 4, 12];
        let result = '';
        segments.forEach((segment, index) => {
            for (let i = 0; i < segment; i++) {
                result += characters.charAt(Math.floor(Math.random() * characters.length));
            }
            if (index < segments.length - 1) {
                result += '-';
            }
        });
        return result;
    }
}
